module.exports = __webpack_public_path__ + "static/media/download-alt.a895c8ee.svg";